/** Backend async checkers for `helpdesk` module */
export enum HelpdeskCheckerKeyEnum {
  /** Check that HelpDesk task(s) exists by identifier(s) */
  HELPDESK_TASK_ASSERT_EXISTS_BY_ID = 'catalog/helpdesk-task-assert-exists-by-id',
  /** Check that HelpDesk task(s) exists by DTO(s) */
  HELPDESK_TASK_ASSERT_EXISTS_BY_DTO = 'catalog/helpdesk-task-assert-exists-by-dto',
  /** Check that HelpDesk task type(s) exists by identifier(s) */
  HELPDESK_TASK_TYPE_ASSERT_EXISTS_BY_ID = 'catalog/helpdesk-task-type-assert-exists-by-id',
  /** Check that HelpDesk task type(s) exists by DTO(s) */
  HELPDESK_TASK_TYPE_ASSERT_EXISTS_BY_DTO = 'catalog/helpdesk-task-type-assert-exists-by-dto',
}
